import React from "react";
import { useHistory, Link } from "react-router-dom";

const PerformanceAnalysisNotFound = (props) => {
  const history = useHistory();

  return (
    <div className="performance-analysis_not-found">
      <div className="not-found_header">
        <div>THIS 2020 YEAR IN</div>
        <div>REVIEW DOESN'T EXIST</div>
      </div>
      <img
        className="not-found_divider"
        src="https://static.bigbrain.gg/assets/lol/performance_analysis/images/performance_analysis_divider.png"
      />
      <div className="not-found_message">
        <div>
          Either this review does not exist or the user who generated it <br /> no longer has U.GG BOOST.
        </div>
      </div>
      <div className="premium-cta">
        <div className="cta-header">GET BOOST</div>
        <div className="cta-text">
          GET YOUR OWN 2020 YEAR IN REVIEW, PLUS <br /> OTHER PERKS
        </div>
        <Link className="btn-light-blue" to={{ pathname: "/", state: { scrollToPlans: true } }}>
          Check Out BOOST
        </Link>
      </div>
    </div>
  );
};

export default PerformanceAnalysisNotFound;
